import React, { useState } from 'react';
import { Star, X } from 'lucide-react';

interface RatingFormProps {
  fornecedor?: string;
  onSubmit: (data: any) => void;
  onCancel?: () => void;
  onClose?: () => void;
}

const RatingForm: React.FC<RatingFormProps> = ({ fornecedor, onSubmit, onCancel, onClose }) => {
  const [rating, setRating] = useState(0);
  const [comentario, setComentario] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (rating === 0) {
      alert('Por favor, selecione uma avaliação');
      return;
    }
    onSubmit({ rating, comentario });
  };

  const handleClose = () => {
    if (onClose) onClose();
    if (onCancel) onCancel();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl max-w-md w-full">
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-900">
              {fornecedor ? `Avaliar ${fornecedor}` : 'Avaliar Fornecedor'}
            </h3>
            <button
              onClick={handleClose}
              className="text-gray-400 hover:text-gray-600"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="form-label">Avaliação</label>
        <div className="flex space-x-1">
          {[1, 2, 3, 4, 5].map((star) => (
            <button
              key={star}
              type="button"
              onClick={() => setRating(star)}
              className="focus:outline-none"
            >
              <Star
                className={`w-8 h-8 ${
                  star <= rating
                    ? 'text-yellow-400 fill-current'
                    : 'text-gray-300'
                }`}
                fill={star <= rating ? 'currentColor' : 'none'}
              />
            </button>
          ))}
        </div>
        <p className="text-sm text-gray-600 mt-1">
          {rating === 0 && 'Selecione uma avaliação'}
          {rating === 1 && 'Muito ruim'}
          {rating === 2 && 'Ruim'}
          {rating === 3 && 'Regular'}
          {rating === 4 && 'Bom'}
          {rating === 5 && 'Excelente'}
        </p>
      </div>

      <div>
        <label className="form-label">Comentário (opcional)</label>
        <textarea
          value={comentario}
          onChange={(e) => setComentario(e.target.value)}
          className="form-textarea"
          placeholder="Conte sua experiência..."
          rows={4}
        />
      </div>

            <div className="flex space-x-3">
              <button type="submit" className="btn btn-primary flex-1">
                Enviar Avaliação
              </button>
              <button
                type="button"
                onClick={handleClose}
                className="btn btn-outline"
              >
                Cancelar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RatingForm; 